<template>
  <CardToolbox>
    <sdPageHeader title="Roles">
      <template #subTitle>
        <span class="title-counter">{{ count }} role{{ count > 0 && count < 2 ? '' : 's' }}</span>
<!--        <sdAutoComplete :dataSource="searchData" width="100%" placeholder="Zoeken op naam" patterns/>-->
      </template>
      <template #buttons>
        <RoleAdd v-if="$can('create', 'role')"/>
      </template>
    </sdPageHeader>
  </CardToolbox>
  <Main>
    <a-row :gutter="15">
      <a-col :md="24">
        <RoleTable/>
      </a-col>
    </a-row>
  </Main>
</template>
<script>
import RoleTable from './component/RoleTable';
import {computed, ref, defineComponent, onMounted} from 'vue';
import {useStore} from 'vuex';
import {Main, CardToolbox} from '../styled';
import RoleAdd from "./RoleAdd";

const RoleList = defineComponent({
  name: 'RoleList',
  components: {RoleAdd, Main, CardToolbox, RoleTable},
  data() {
    return {
      showEditDrawer: false,
    }
  },
  setup() {
    const {state, dispatch} = useStore();
    const searchData = computed(() => state.headerSearchData);
    const count = computed(() => state.role.count);
    const selectedRowKeys = ref(0);
    const selectedRows = ref(0);

    onMounted(() => {
      dispatch('getRoles', {page: state.role.currentPage, pageSize: state.role.pageSize});
    });

    return {
      searchData,
      selectedRowKeys,
      selectedRows,
      count,
    };
  },
});

export default RoleList;
</script>
